var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useMemo, useState } from 'react';
import Fuse from 'fuse.js';
/**
 * Hook for searching and filtering spaces by name using Fuse.js fuzzy search.
 */
export var useSpaceSearch = function (spaces) {
    var _a = __read(useState(''), 2), searchQuery = _a[0], setSearchQuery = _a[1];
    // Configure Fuse instance
    var fuse = useMemo(function () {
        if (!spaces || spaces.length === 0)
            return null;
        var options = {
            keys: ['name'],
            threshold: 0.2,
            includeMatches: true,
        };
        return new Fuse(spaces, options);
    }, [spaces]);
    var searchResults = useMemo(function () {
        if (!spaces || spaces.length === 0)
            return undefined;
        var searchTerm = searchQuery.trim().toLowerCase();
        if (searchTerm === '') {
            return spaces;
        }
        if (!fuse)
            return [];
        var results = fuse.search(searchTerm);
        return results.map(function (result) { return result.item; });
    }, [spaces, searchQuery, fuse]);
    return {
        searchQuery: searchQuery,
        setSearchQuery: setSearchQuery,
        searchResults: searchResults,
    };
};
